import axios from 'axios'
import staticVars from '../static-vars/static-vars'
import qs from 'qs'
const restBase = staticVars.baseUrl + '/wp-json'

export const getImage = (id, callback) => {
  axios.get(`${restBase}/customrest/v1/getImage?id=${id}`).then((response) => {
    callback(response.data)
  }).catch((error) =>{
    console.log(error)
  })
}

export const getPosts = (filter = [], callback) => {
  axios.get(`${restBase}/customrest/v1/getPosts?${qs.stringify(filter)}`)
    .then((data) => {
      callback(data)
    }).catch((error) =>{
      console.log(error)
    })
}

export const getTerms = (filter = [], callback) => {
  axios.get(`${restBase}/customrest/v1/getTerms?${qs.stringify(filter)}`)
    .then((data) => {
    callback(data)
  }).catch((error) =>{
    console.log(error)
  })
}


export const getSiteName = (callback) => {
  axios.get(restBase + '/customrest/v1/getSiteName').then((data) => {
    callback(data)
  }).catch((error) =>{
    console.log(error)
  })
}

export const getLexicon = (lang, callback) => {
  axios.get(restBase + '/customrest/v1/getLexicon?lang=' + lang).then((data) => {
    callback(data)

  }).catch((error) =>{
    console.log(error)
  })
}

export const getOptions = (lang, callback) => {
  axios.get(restBase + '/customrest/v1/getOptions?lang=' + lang).then((data) => {
    callback(data)

  }).catch((error) =>{
    console.log(error)
  })
}



export const getFormData = (formId, callback) => {

  axios.get(restBase + '/gf/v2/forms/' + formId, {
    auth: {
      username: 'ck_d28360e7c0ef8ff2dbeb74c55b9bf5679a172c0e',
      password: 'cs_1a536307f02ee29bb6dbff0bbd30d7ca317934ba',
    }
  })
    .then((response) => {
      callback(response)
    }).catch((error) =>{
      console.log(error)
    })
}

export const submitFormEntry = (data, params, callback) => {
  axios.post(restBase + '/gf/v2/forms/' + data.form_id + '/submissions/' , data, {
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    auth: {
      username: 'ck_d28360e7c0ef8ff2dbeb74c55b9bf5679a172c0e',
      password: 'cs_1a536307f02ee29bb6dbff0bbd30d7ca317934ba',
    }
  })
    .then((data) => {
      console.log('success')

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event' : 'formSentSuccessful'
      })


      callback(data)
    }).catch((error) =>{
      console.log('error')
      callback(error.response)
    })
}

export const submitCaptcha = (data, callback) => {
  //let url = 'https://www.google.com/recaptcha/api/siteverify?secret='+ data.secret +'&response=' + data.response;
  let url = staticVars.baseUrl + '/wp-json/customrest/v1/recaptcha'
  axios.post(
    url,
    {},
    {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      params: {
        secret: data.secret,
        response: data.response
      }
    })
    .then((data) => {
      callback(data)
    }).catch((error) =>{
      console.log('error')
      callback(error.response)
    })
}

export const getVehiclesListContent = (data, callback) => {
  // vehtyp = vehicles types
  // make = brand
  // lng = language
  // model = model
  // fuel = fuel type
  // body = aufbauarten
  // trans = gretiebe
  // page

  axios.get(staticVars.baseUrl + `/wp-json/customrest/v1/getVehiclesListContent?member=${data.member}&make=${data.makeId}&page=${data.page}&lng=${data.lng}`).then((response) => {
    callback(response)
  }).catch((error) =>{
    console.log(error)
  })
}

export const getVehiclesListSummaryContent = (data, callback) => {
  axios.get(staticVars.baseUrl + `/wp-json/customrest/v1/getVehiclesListSummaryContent?member=${data.member}&page=${data.page}&lng=${data.lng}`).then((response) => {
    callback(response)
  }).catch((error) =>{
    console.log(error)
  })
}

export const getVehicleContent = (data, callback) => {

  axios.get(staticVars.baseUrl + `/wp-json/customrest/v1/getVehicleContent?id=${data.id}&member=${data.member}&lng=${data.lng}`).then((response) => {
    // console.log('response ', response)
    callback(response)
  }).catch((error) =>{
    console.log(error)
  })
}
